export default __webpack_public_path__ + "static/improve-quality-of-life-accomplishment-7f-b4b9a2a3293a8f7e1d46e39dbfbc14ff.webp";